import { authInvoice, conciliatedInvoice } from "shared/models"
import { IResponseStates } from "shared/models/store/IInvoiceStates"

export const convertInvoiceStatesAutorizations = (options: IResponseStates[]): IResponseStates[] => {
    const currentOptions = options.map(state => {
        return {
            id: state.id,
            code: state.code,
            name: state.name,
            group: {
                code: state.group?.code || '',
                name: state.group?.name || ''
            }
        }
      })

    // Filter by group code first
    const filteredByGroup = currentOptions.filter(state => [authInvoice, conciliatedInvoice].includes(state.group.code))

    // Additional filtering:
    // - From conciliatedInvoice: remove "7.2.1" (Factura con glosas Enviadas) and "7.2.2" (Factura con Glosas Respondidas)
    // - From authInvoice: keep only "9.3" (Factura con autorización de pagos)
    return filteredByGroup.filter(state => {
        if (state.group.code === conciliatedInvoice) {
            // Remove specific codes from conciliation
            return !["7.2.1", "7.2.2"].includes(state.code)
        }
        if (state.group.code === authInvoice) {
            // Keep only "9.3" from authorization
            return state.code === "9.3"
        }
        return true
    })
}